import loadable from "@loadable/component";
import StatusIcon from "../../../Icons/StatusIcon";

const VehicleTypeListComponent = loadable(
  () => import("../../../components/Settings/VehicleType/VehicleTypeList")
);

const VehicleTypeList = () => {
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <StatusIcon />
        <span className="text-[#5E5757] font-bold text-xl">Vehicle Type</span>
      </div>
      <VehicleTypeListComponent />
    </>
  );
};



export default VehicleTypeList
